import { render, staticRenderFns } from "./GoodTitle.vue?vue&type=template&id=156f8e1b&scoped=true&"
import script from "./GoodTitle.vue?vue&type=script&lang=js&"
export * from "./GoodTitle.vue?vue&type=script&lang=js&"
import style0 from "./GoodTitle.vue?vue&type=style&index=0&id=156f8e1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f8e1b",
  null
  
)

export default component.exports